import Image from "next/image";

export function BrandMark({
  compact = false,
  invert = false,
}: {
  compact?: boolean;
  invert?: boolean;
}) {
  return (
    <span
      className={`brand-mark ${compact ? "brand-mark-compact" : ""} ${invert ? "brand-mark-invert" : ""}`}
    >
      <Image
        className="brand-logo-color"
        src="/brand/asv-logo-color.svg"
        alt="Grupo ASV"
        width={174}
        height={84}
        priority
      />
      <Image
        className="brand-logo-white"
        src="/brand/asv-logo-white.svg"
        alt="Grupo ASV"
        width={174}
        height={84}
        priority
      />
    </span>
  );
}
